import SiteHeader from "@/components/suffa/SiteHeader";
import SiteFooter from "@/components/suffa/SiteFooter";
import Hero from "@/components/suffa/Hero";
import LaunchOfferBanner from "@/components/suffa/LaunchOfferBanner";
import LocalReach from "@/components/suffa/LocalReach";
import { useSeoTitle } from "@/lib/seo";

export default function Home() {
  useSeoTitle("Muslim Matrimony Surat | Suffa Matrimony — Nikah Rishtas");
  return (
    <div className="suffa-page">
      <SiteHeader />
      <main className="suffa-main">
        <LaunchOfferBanner />
        <Hero />
        <LocalReach />
      </main>
      <SiteFooter />
    </div>
  );
}
